import { Component, EventEmitter, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { TylerMatTableDataSource } from '../../../shared-components/angular-material/extended.class';
import { detailExpand } from '../../../shared-components/angular-material/mat-animations';
import { AriaDirective } from '../../../shared-components/directives/aria.directive';
import { SharedService } from '../../../shared-components/shared.service';
import { CourseSchedule } from '../../../shared-components/student/course-schedule.model';
import { StudentService } from '../../../shared-components/student/student.service';
import { UserService } from '../../../shared-components/user/user.service';
import { SendEmailService } from '../../../shared-modules/send-email/send-email.service';

@Component({
    selector: 'by-schedule-table',
    templateUrl: './by-schedule-table.component.html',
    animations: [detailExpand],
})
export class ByScheduleTableComponent implements OnInit, OnDestroy {

    // ----------Angular Material------------------------------------
    angularMatData = new TylerMatTableDataSource();
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    columnsToDisplayCourse: string[] = ['More', 'Meets', 'Dropped', 'Term', 'Course-Section', 'Course', 'TeacherName', 'Absences', 'Tardies'];
    @Input() courseSchedules: CourseSchedule[];
    @Input() calendarUseAttendanceTypes: boolean;
    clearFilterEvent = new EventEmitter<any>();
    @Input() V10: boolean;

    constructor(
        private sharedService: SharedService,
        private sendEmailService: SendEmailService,
        private studentService: StudentService,
        private userService: UserService,
        private router: Router) {
    }

    ngOnInit() {
        this.angularMatData.data = this.courseSchedules;
        if (!this.V10) {
            this.columnsToDisplayCourse = ['More', 'Meets', 'Term', 'Course-Section', 'Course', 'TeacherName', 'Absences', 'Tardies'];
        }

        //  Custom sorting for case here Academic Year starts with letters
        //  Extracts last two characters and returns the resulting substring if it is a number
        this.angularMatData.sortingDataAccessor = (item: any, property: string) => {
            if (property == 'Course-Section') {
                return item['SubjectCode'] + item['Section'];
            }
            //  Default sorting
            else {
                return this.angularMatData.defaultSortingAccessor(item, property);
            }
        };

        this.angularMatData.sort = this.sort;
    }

    ngAfterViewInit() {
        if (this.studentService.selectedCourse.SubjectCode != undefined) {
            const course = this.courseSchedules.filter(o => o.SubjectCode == this.studentService.selectedCourse.SubjectCode)[0];
            this.angularMatData.toggleExpanded(course);
        }
    }

    ngOnDestroy() {
    }

    sendEmail(teacherName: string, teacherEmail: string) {
        this.sendEmailService.teacherName = teacherName;
        this.sendEmailService.teacherEmailAddress = teacherEmail;
        if (!this.userService.studentInformationView) {
            this.router.navigateByUrl('/student360/sendEmail');
        }
        else {
            this.userService.updateStudentViewRoute('/student360/sendEmail');
        }
    }

    // ----------Angular Material------------------------------------
    toggleExpanded(row: any) {
        this.angularMatData.toggleExpanded(row);
    }

    checkExpanded(row: any): boolean {
        return this.angularMatData.checkExpanded(row);
    }

    expandAll(expand: boolean) {
        this.sharedService.updateShowSpinner(true);
        setTimeout(() => {
            this.angularMatData.expandAll(expand);
            this.sharedService.updateShowSpinner(false);
        }, 100);
    }

    rowKeyPress(event: KeyboardEvent, row: any) {
        this.angularMatData.rowKeyPress(event, row);

    }

    getAriaRowByCourse(row: CourseSchedule): string {
        const colList: string[] = ['Meets',
            'Dropped',
            'Term',
            'Course-Section',
            'Course Name',
            'Teacher',
            'Absences',
            'Tardies'];

        const dataList: string[] = [row.Meets,
        row.Dropped,
        row.Term,
        row.SubjectCode.concat('-', row.Section),
        row.Course,
        row.TeacherName,
        row.Absences.toString(),
        row.Tardies.toString()];

        return AriaDirective.concatAriaStrings(colList, dataList) + (row.AttendanceDetails.length > 0 ? ' Expand for more details' : ' No additional details');
    }

}
